import Vue from 'vue'
import Vuex from 'vuex'
import axios from '@/api/index'

import Nprogress from 'nprogress';
import globalAxios from 'axios'

import router from '@/router/index'
import qs from 'qs'
import moment from "moment";
Vue.use(Vuex)

const state = {
    setTopBoxList: [],
    setTopBoxPermission: [],
}
const mutations = {
    CLEAR_STBOX_STATE(state) {
        state.setTopBoxList = [];
        state.setTopBoxPermission = [];
    },
    SET_SET_TOP_BOX_LIST(state, userData) {
        var tData = {};
        var parseData = JSON.parse(userData.message);
        state.setTopBoxPermission = userData.permissions;
        state.setTopBoxList = [];

        if (parseData != null) {
            tData[userData.accountId + '-setTopBoxList'] = parseData;
            state.setTopBoxList = tData;
        }
    },
    DELETE_SET_TOP_BOX_LIST(state, data) {
        var iptvIds = data.iptvData;
        var accountId = data.accountId;
        if (Object.keys(state.setTopBoxList).length != 0) {
            var index = state.setTopBoxList[accountId + "-setTopBoxList"].findIndex(iptv => iptv.SetTopBox.id == iptvIds);
            if (index != -1) {
                state.setTopBoxList[accountId + "-setTopBoxList"].splice(index, 1);
            }
        }
    },
    ADD_SET_TOP_BOX_LIST(state, data) {
        var iptvData = data.stbData;
        var idx = data.idx;
        var userId = data.userId;
        var accountId = data.accountId;
        if (Object.keys(state.setTopBoxList).length != 0 && state.setTopBoxList != 'noData') {
            if (state.setTopBoxList != 'noData') {
                state.setTopBoxList[accountId + "-setTopBoxList"].push(iptvData);
                state.setTopBoxList[accountId + '-setTopBoxList'][idx].SetTopBox.user_id = userId;
                state.setTopBoxList[accountId + '-setTopBoxList'][idx].SetTopBox.account_id = accountId;
            }
        } else {
            var dataSet = {}
            dataSet[accountId + "-setTopBoxList"] = iptvData;
            state.setTopBoxList = dataSet;
        }
    },
    ADD_DELETE_LINK_MAC(state, data) {
        var id = data.id;
        var val = data.val;
        var accountId = data.accountId;
        if (Object.keys(state.setTopBoxList).length != 0 && state.setTopBoxList != 'noData') {
            var index = state.setTopBoxList[accountId + "-setTopBoxList"].findIndex(iptv => iptv.SetTopBox.id == id);
            if (index != -1) {
                state.setTopBoxList[accountId + '-setTopBoxList'].splice(index, 1);
            } else {
                var idx = Object.keys(state.setTopBoxList).length;
                state.setTopBoxList[accountId + '-setTopBoxList'].push(val);
            }
        }
    },
    LINK_MAC_TO_USER(state, data) {
        var id = data.id;
        var type = (data.linkType == false) ? false : true;
        var accountId = data.accountId;
        var userName = data.userName;
        var userId = data.userId;
        if (Object.keys(state.setTopBoxList).length != 0 && state.setTopBoxList != 'noData') {
            var index = state.setTopBoxList[accountId + "-setTopBoxList"].findIndex(iptv => iptv.SetTopBox.id == id);
            if (index != -1) {
                state.setTopBoxList[accountId + '-setTopBoxList'][index].link = type;
                state.setTopBoxList[accountId + '-setTopBoxList'][index].User.username = userName;
                state.setTopBoxList[accountId + '-setTopBoxList'][index].SetTopBox.user_id = userId;
                state.setTopBoxList[accountId + '-setTopBoxList'][index].SetTopBox.account_id = accountId;
            }
        }
    },
    CHANGE_ADMIN_STATUS(state, data) {
        var id = data.id;
        var type = (data.changeStatus == 0) ? 1 : 0;
        var accountId = data.accountId;
        var stat = "";
        if (type == 0) {
            stat = "Off";
        } else {
            stat = 'On';
        }
        if (Object.keys(state.setTopBoxList).length != 0 && state.setTopBoxList != 'noData') {
            var index = state.setTopBoxList[accountId + "-setTopBoxList"].findIndex(iptv => iptv.SetTopBox.id == id);
            if (index != -1) {
                state.setTopBoxList[accountId + '-setTopBoxList'][index].adStatus = type;
                state.setTopBoxList[accountId + '-setTopBoxList'][index].SetTopBox.status = stat;
            }
        }
    },
    CHANGE_TARIFF_PLAN_NAME(state, data) {
        var id = data.id;
        var tariffPlan = data.tariffPlan;
        var tariffPlanName = data.tariffPlanName;
        var accountId = data.accountId;
        if (Object.keys(state.setTopBoxList).length != 0 && state.setTopBoxList != 'noData') {
            var index = state.setTopBoxList[accountId + "-setTopBoxList"].findIndex(iptv => iptv.SetTopBox.id == id);
            if (index != -1) {
                state.setTopBoxList[accountId + '-setTopBoxList'][index].SetTopBox.tariff_plan = tariffPlan;
                state.setTopBoxList[accountId + '-setTopBoxList'][index].SetTopBox.tariff_plan_name = tariffPlanName;
            }
        }
    }
}
const actions = {
    clearSTBoxState({
        commit,
        dispatch
    }) {
        commit('CLEAR_STBOX_STATE')
    },
    fetchSTBoxesList({
        commit,
        dispatch
    }, authData) {
        Nprogress.start()
        return new Promise((resolve, reject) => {
            axios.get('/iptv/get_setTopBox_data/' + authData.iptvName + "/" + authData.stbStatus + "/" + authData.adminStatus + "/" + authData.billedStatus + "/" + true + '/' + authData.limit + '/' + authData.page + '/' + authData.sorting)
                .then(res => {
                    Nprogress.done()
                    if (res.data.status == "redirect") {
                        router.push(res.data.message);
                    } else {
                        commit('SET_SET_TOP_BOX_LIST', res.data)
                        resolve(res.data);
                    }
                })
                .catch(error => console.log(error))
        });
    },
    fetchUserSTBoxesList({
        commit,
        dispatch
    }, authData) {
        Nprogress.start()
        return new Promise((resolve, reject) => {
            axios.post('/users/user_stb_data/1', qs.stringify(authData, {
                parseArrays: false
            }))
                .then(res => {
                    Nprogress.done()
                    commit('SET_SET_TOP_BOX_LIST', res.data)
                    resolve(res.data);
                })
                .catch(error => console.log(error))
        });
    },
    fetchSTBoxesPostList({
        commit,
        dispatch
    }, authData) {
        Nprogress.start()
        return new Promise((resolve, reject) => {
            axios.post('/iptv/get_setTopBox_data/' + authData.iptvName + "/" + authData.stbStatus + "/" + authData.adminStatus + "/" + authData.billedStatus + "/" + true + '/' + authData.limit + '/' + authData.page + '/' + authData.sorting, qs.stringify(authData, {
                parseArrays: false
            }))
                .then(res => {
                    Nprogress.done()
                    if (res.data.status == "redirect") {
                        router.push(res.data.message);
                    } else {
                        commit('SET_SET_TOP_BOX_LIST', res.data)
                        resolve(res.data);
                    }
                })
                .catch(error => console.log(error))
        });
    },
    createSTBModalSubmit({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/iptv/add_settop_box', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide()
                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    var dataList = {
                        stbData: response.data.newData,
                        accountId: response.data.accountId,
                        idx: response.data.idx,
                        userId: postData.userid
                    }
                    commit('ADD_SET_TOP_BOX_LIST', dataList)

                    resolve(response.data);
                })
                .catch(error => console.log(error));
        });
    },
    deleteSTBoxSubmit({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {

            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/iptv/delete_stb', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide()
                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    var successData = {
                        iptvData: postData.stbId,
                        accountId: postData.accountId
                    }
                    commit('DELETE_SET_TOP_BOX_LIST', successData);
                    resolve(response.data);
                })
                .catch(error => console.log(error));
        });
    },
    syncSTBoxSubmit({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {

            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/iptv/stb_refresh', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide()
                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    resolve(response.data);
                })
                .catch(error => console.log(error));
        });
    },
    linkUserSTBSubmit({
        commit,
        dispatch
    }, authData) {
        return new Promise((resolve, reject) => {

            let loader = Vue.$loading.show({
                canCancel: false,
            });

            axios.post('/iptv/link_stb_to_user', qs.stringify(authData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide()
                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    if (authData.userPg == true) {
                        var successData = {
                            val: authData.val,
                            id: authData.stbId,
                            accountId: authData.accountId,
                        }
                        commit('ADD_DELETE_LINK_MAC', successData)
                    } else {
                        var successData = {
                            id: authData.stbId,
                            accountId: authData.accountId,
                            linkType: authData.linkType,
                            userName: response.data.userName,
                            userId: response.data.jsonNew
                        }
                        commit('LINK_MAC_TO_USER', successData)
                    }

                    resolve(response.data);
                })
                .catch(error => console.log(error));
        });
    },
    unlinkUserSTBSubmit({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {

            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/iptv/unlink_stb', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide()
                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    if (postData.userPg == true) {
                        var successData = {
                            id: postData.stbId,
                            accountId: postData.accountId,
                        }
                        commit('ADD_DELETE_LINK_MAC', successData)
                    } else {
                        var successData = {
                            id: postData.stbId,
                            accountId: postData.accountId,
                            linkType: postData.linkType,
                            userName: "",
                            userId: "NULL"
                        }
                        commit('LINK_MAC_TO_USER', successData)
                    }

                    resolve(response.data);
                })
                .catch(error => console.log(error));
        });
    },
    adminStatusSubmit({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {

            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/iptv/change_admin_status', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide()
                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    var successData = {
                        id: postData.stbId,
                        accountId: postData.accountId,
                        changeStatus: postData.changeStatus,
                    }
                    commit('CHANGE_ADMIN_STATUS', successData)

                    resolve(response.data);
                })
                .catch(error => console.log(error));
        });
    },
    changeTarrifPlanSubmit({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {

            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/iptv/change_tariff_plan', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide()
                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    var successData = {
                        id: postData.stbId,
                        accountId: postData.accountId,
                        tariffPlan: postData.tariffPlan,
                        tariffPlanName: postData.tariffPlanName,
                    }
                    commit('CHANGE_TARIFF_PLAN_NAME', successData)

                    resolve(response.data);
                })
                .catch(error => console.log(error));
        });
    },
    changeMacSubmit({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {

            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/iptv/replace_stb', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide()
                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    resolve(response.data);
                })
                .catch(error => console.log(error));
        });
    },
    selectedSyncSubmit({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {

            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/iptv/add_all_settop_box', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide()
                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    resolve(response.data);
                })
                .catch(error => console.log(error));
        });
    },
    importSTBoxSubmit({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {

            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios
                .post("/iptv/import_settop_box", postData, {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                })
                .then(response => {
                    loader.hide()
                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    resolve(response.data);
                })
                .catch(error => console.log(error));
        });
    },
    selectedExportSTBSubmit({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {

            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/iptv/export_settop_box', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide()
                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    resolve(response.data);
                })
                .catch(error => console.log(error));
        });
    },
}
const getters = {
    getSTBoxListGetters: state => {
        return state.setTopBoxList;
    },
    getSTBoxPermissionGetters: state => {
        return state.setTopBoxPermission;
    },
}
export default {
    state,
    mutations,
    actions,
    getters
}